module.exports = __webpack_public_path__ + "img/pending-approval-risk.f1fbb29b.png";